/*  ==========================================================================
    PREVENT LINK ON TOUCH
    Add functionality for the first main navigation level, so that
    the navigation is more user-friendly on touch-devices.
    ========================================================================== */

/*
 * IMPORTS
 */

import $ from 'jquery';
import * as utils from "../../utilities/utils";


/*
 * INIT
 * Function which initialize the trigger for the first level-links in the main
 * navigation menu. It triggers only on touch devices. The corresponding links
 * doesn't link on the first touch-click but on the second. The first click opens
 * just the submenu so you can have access to them, too.
 *
 * @param {string} linkClass - the class for the first level-links in the menu
 */

export function init(linkClass) {
    let $links = $(`.${linkClass}`);
    if ($links.length) {
        $('html').on('touchstart', function(e){
            let $target = $(e.target);
            if (!$target.hasClass(linkClass)) {
                $links.removeClass(`${linkClass}--set`);
            }
            if ($target.hasClass(linkClass) && !$target.hasClass(`${linkClass}--set`)) {
                $links.removeClass(`${linkClass}--set`);
            }
            $links.on('click', function(event) {
                let $this = $(this);
                if(!$this.hasClass(`${linkClass}--set`)) {
                    event.preventDefault();
                    $links.removeClass(`${linkClass}--set`);
                    $this.addClass(`${linkClass}--set`);
                }
            });
        });
    } else {
        //console.log('No elements for \'preventLinkOnHover\' found.');
    }
}


// WEBPACK FOOTER //
// ./source/js/utilities/lib/prevent-link-on-touch.js